var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.buildCalendar)?_c('calendar-structure',{key:_vm.calendarEvent}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }